import { useState } from "react";
import { useEffect } from "react";
import "./styles/Blog.css";
import Header from "./Header";
import Footer from "./Footer";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

function BlogPost() {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(
      `https://stari-vlah-strapi-54837937b4c4.herokuapp.com/api/blogs?filters[slug][$eq]=${slug}&populate=*`
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.data.length > 0) {
          setBlog(data.data[0]);
        }
      })
      .catch((err) => console.error("Error fetching blog:", err))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <p>Učitavanje...</p>;
  if (!blog) return <p>Blog nije pronađen.</p>;

  const {
    Title,
    publishDate,
    coverImage,
    coverAlt,
    meta_description,
    meta_keywords,
    firstTextContent,
  } = blog;

  const imageUrl = coverImage?.url || "/images/default-blog.jpg";

  const renderTextContent = (content) => {
    return content.map((block, index) => {
      switch (block.type) {
        case "paragraph":
          return (
            <p key={index} className="blogPostText">
              {block.children.map((child, i) => {
                let text = child.text;

                if (child.bold) text = <strong key={i}>{text}</strong>;
                if (child.italic) text = <em key={i}>{text}</em>;
                if (child.strikethrough) text = <del key={i}>{text}</del>;
                if (child.underline) text = <u key={i}>{text}</u>;
                if (child.type === "link") {
                  text = (
                    <a
                      key={i}
                      href={child.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="blogPostLink"
                    >
                      {child.children[0]?.text}
                    </a>
                  );
                }

                return text;
              })}
            </p>
          );
        case "heading":
          const HeadingTag = `h${block.level}`;
          return (
            <HeadingTag key={index} className="headerBlogPostText">
              {block.children.map((child, i) => child.text)}
            </HeadingTag>
          );
        case "list":
          if (block.format === "unordered") {
            return (
              <ul key={index}>
                {block.children.map((listItem, i) => (
                  <li key={i} className="blogPostText">
                    {listItem.children.map((child, j) => child.text)}
                  </li>
                ))}
              </ul>
            );
          }
          if (block.format === "ordered") {
            return (
              <ol key={index}>
                {block.children.map((listItem, i) => (
                  <li key={i} className="blogPostText">
                    {listItem.children.map((child, j) => child.text)}
                  </li>
                ))}
              </ol>
            );
          }
          return null;
        case "image":
          return (
            <div key={index} className="blog-image-container">
              <img
                src={block.image.url}
                alt={
                  block.image.alternativeText ||
                  "Apartman Stari Vlah Zlatibor Blog - Smestaj Zlatibor"
                }
                className="blog-image"
              />
            </div>
          );
        default:
          return null;
      }
    });
  };

  return (
    <>
      <Helmet>
        <title>
          {Title} - Ekskluzivan Blog o Zlatiboru | Apartman Stari Vlah
        </title>
        <meta
          name="description"
          content={
            meta_description ||
            "Saznajte više o Apartmanu Stari Vlah Zlatibor i pronađite idealan smeštaj u prirodi!"
          }
        />
        <link
          rel="canonical"
          href={`https://starivlahzlatibor.rs/blog/${slug}`}
        />
        <meta name="keywords" content={meta_keywords} />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            headline: {Title},
            datePublished: {publishDate},
            image: {imageUrl},
            author: {
              "@type": "Organization",
              name: "Apartman Stari Vlah Zlatibor",
            },
            publisher: {
              "@type": "Organization",
              name: "Apartman Stari Vlah Zlatibor",
              logo: {
                "@type": "ImageObject",
                url: "https://starivlahzlatibor.rs/images/logoKvadratBezPozadine.webp",
              },
            },
            description:
              meta_description ||
              "Saznajte više o Apartmanu Stari Vlah Zlatibor i pronađite idealan smeštaj u prirodi!",
            mainEntityOfPage: {
              "@type": "WebPage",
              "@id": `https://starivlahzlatibor.rs/blog/${slug}`,
            },
          })}
        </script>
      </Helmet>
      <Header />
      <div className="blogPostImageDiv">
        <img
          src={imageUrl}
          alt={coverImage?.coverAlt || "Apartman Stari Vlah Zlatibor Blog"}
          className="blogPostMainImage"
        />
        <motion.h1 className="blogPostMainTitle" initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1.3, ease: "easeOut" }}>{Title}</motion.h1>
      </div>
      <div className="blog-content">
        <div className="blog-text">
          {firstTextContent && renderTextContent(firstTextContent)}
        </div>
      </div>
      <p className="publishDate">
        {new Date(publishDate).toLocaleDateString()}
      </p>
      <div className="blogPostFooterDiv">
        <img
          src="/images/zlatiborPanorama.jpg"
          className="blogPostFooterImg"
          alt="Zlatibor panorama - Apartman Stari Vlah Zlatibor Smestaj"
        />
        <div className="blogPostFooterBookingDiv">
          <img
            src="/images/logoKvadratBezPozadine.webp"
            className="logoImg"
            alt="Logo Apartman Stari Vlah Zlatibor - Povoljan Smestaj"
          />
          <p className="blogPostFooterParagraph">
            Rezervišite vaš savršen smeštaj na vreme!
          </p>
          <button
            className="blogPostFooterBtn"
            onClick={() => navigate("/booking")}
          >
            REZERVIŠITE{" "}
            <img src="/images/rightArrow.png" className="rightArrowFooterImg" alt="Zlatibor Pogled na planinu Apartman Stari Vlah" />
          </button>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default BlogPost;
